import { axios, Response } from '../index'

const deletePatientById = (patientId: string): Response<null> => {
  return axios.delete(`/v1/patients/${patientId}`)
}

export default deletePatientById
